export const TOKEN_BUFFER_MS = 10 * 60 * 1000; // 10 minutes buffer before token expiration - increased to handle extended idle periods
export const MILLISECONDS_PER_SECOND = 1000;

export const OAUTH2_PATHS = {
  AUTHORIZE: '/OAuth2/Authorize',
  TOKEN: '/OAuth2/Token',
  ON_PREM_AUTHORIZE: '/MaximizerWebAuthentication/OAuth2/Authorize',
  ON_PREM_TOKEN: '/MaximizerWebAuthentication/OAuth2/Token',
} as const;

export const GRANT_TYPES = {
  AUTHORIZATION_CODE: 'authorization_code',
  REFRESH_TOKEN: 'refresh_token',
} as const;

export const CODE_CHALLENGE_METHOD = 'SHA256';
export const SCOPE = 'data';
export const OAUTH2_RESPONSE_TYPE = 'code';
export const DATABASE_LOGIN_HINT_PREFIX = 'd ';

export const STORAGE_KEY_PARTITION = 'Mx-PartitionKey';
export const STORAGE_NAME_TOKEN = ':Mx-Id';
export const STORAGE_NAME_REFRESH_IN_PROGRESS = ':Mx-IdProgress';
export const STORAGE_NAME_USER_ID = ':Mx-UserId';
export const STORAGE_NAME_USER_EMAIL = ':Mx-UserEmail';
export const STORAGE_NAME_LOGIN_DETAILS = ':Mx-GlobalDetails';
export const STORAGE_NAME_ON_PREM_HOST = ':Mx-OnPremHost';
export const STORAGE_NAME_LAST_USE = ':Mx-LastUse';

export const AUTH_ERROR_SESSION_KEY = 'authError';
export const AUTH_CLEARED_MARKER_KEY = 'Mx-ClearedReason';
export const IS_CLOUD_STORAGE_KEY = 'isCloud';

export const ENHANCED_STORAGE_KEYS = {
  OAUTH2_TOKEN: 'oauth2_token',
  USER_CREDENTIALS: 'user_credentials',
  LOGIN_DETAILS: 'login_details',
  ACCESS_TOKEN: 'access_token',
  REFRESH_TOKEN: 'refresh_token',
  TOKEN_METADATA: 'token_metadata',
} as const;

export const HTTP_STATUS = {
  NETWORK_ERROR: 0,
  OK: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const HTTP_PARAMS = {
  GRANT_TYPE: 'grant_type',
  CLIENT_ID: 'client_id',
  CODE: 'code',
  REDIRECT_URI: 'redirect_uri',
  REFRESH_TOKEN: 'refresh_token',
  CODE_VERIFIER: 'code_verifier',
  LOGIN_HINT: 'login_hint',
} as const;

export const URL_PARAMS = {
  RESPONSE_TYPE: 'response_type',
  CLIENT_ID: 'client_id',
  REDIRECT_URI: 'redirect_uri',
  STATE: 'state',
  CODE_CHALLENGE: 'code_challenge',
  CODE_CHALLENGE_METHOD: 'code_challenge_method',
  LOGIN_HINT: 'login_hint',
  NONCE: 'nonce',
  SCOPE: 'scope',
} as const;

export const FIRST_WORKSPACE_INDEX = 0;
export const URL_PREFIX_CHECK_LENGTH = 10;
export const DEFAULT_BROWSER_ONLY_EXPIRES_IN = 300;
